module.exports = __webpack_public_path__ + "img/icon_2 (2).9585500f.png";